export default views => {
  if (!views) {
    return views;
  }
  let normalise = views >= 1e6 ? 1e6 : views > 1e3 ? 1e3 : 1;
  let str = views >= 1e6 ? 'M' : views > 1e3 ? 'k' : '';
  let count = Math.floor(views / normalise);
  return `${count}${str}`;
};
